import React, { useState, useEffect } from "react";
import "./EditDatabaseEntries.css";

export default function EditDatabaseEntries({
  editOpen,
  people,
  editKey,
  toggleEdit,
  editPeople,
}) {
  const [person, setPerson] = useState(
    people.find((person) => person.key === editKey)
  );
  const [firstNameEdit, setFirstNameEdit] = useState(person.firstName);
  const [lastNameEdit, setLastNameEdit] = useState(person.lastName);
  const [phoneEdit, setPhoneEdit] = useState(person.phone);
  const [firstNameValid, setFirstNameValid] = useState(true);
  const [lastNameValid, setLastNameValid] = useState(true);
  const [phoneValid, setPhoneValid] = useState(true);
  const [phoneFormatValid, setPhoneFormatValid] = useState(true);

  useEffect(() => {
    if (editKey) {
      setPerson(people.find((person) => person.key === editKey));
      setFirstNameEdit(person.firstName);
      setLastNameEdit(person.lastName);
    }
  }, [editOpen, person, editKey, people]);

  let hidden = "hidden";
  editOpen ? (hidden = "") : (hidden = "hidden");

  const firstNameEditHandler = (e) => {
    e.preventDefault();
    setFirstNameEdit(e.target.value);
  };

  const lastNameEditHandler = (e) => {
    e.preventDefault();
    setLastNameEdit(e.target.value);
  };

  const phoneEditHandler = (e) => {
    e.preventDefault();
    setPhoneEdit(e.target.value);
  };

  const submitBtnHandler = (e) => {
    const valid = validation();
    const formatValid = phoneFormatValidator(phoneEdit);
    if (valid && formatValid) {
      editPeople(
        firstNameEdit.trim(),
        lastNameEdit.trim(),
        phoneEdit,
        person.key
      );

      setFirstNameValid(true);
      setLastNameValid(true);
      setPhoneValid(true);
    }
  };

  const cancelBtnHandler = (e) => {
    e.preventDefault();
    toggleEdit(person.key);
  };

  const validation = () => {
    if (firstNameEdit === "" || lastNameEdit === "" || phoneEdit === "") {
      firstNameEdit === "" ? setFirstNameValid(false) : setFirstNameValid(true);
      lastNameEdit === "" ? setLastNameValid(false) : setLastNameValid(true);
      if (phoneEdit === "") {
        setPhoneValid(false);
      } else {
        setPhoneValid(true);
      }
      return;
    } else {
      return true;
    }
  };

  const phoneFormatValidator = (num) => {
    if (phoneEdit === "") return;

    const format = /^\d{3}-\d{3}-\d{4}$/;
    if (num.match(format)) {
      setPhoneFormatValid(true);
      return true;
    } else {
      setPhoneFormatValid(false);
      return false;
    }
  };

  return (
    <div className={`EditDatabaseEntriesMain border-top mt-5 ${hidden}`}>
      <h3 className="mt-3">Edit</h3>
      <form>
        <div>
          <label htmlFor="firstNameEdit" className="form-label">
            First Name
          </label>
          <input
            type="text"
            id="firstNameEdit"
            className="form-control"
            value={firstNameEdit ? firstNameEdit : ""}
            onChange={firstNameEditHandler}
          ></input>
          {!firstNameValid && (
            <p className="validationError">Please enter first name</p>
          )}
        </div>
        <div>
          <label htmlFor="lastNameEdit" className="form-label mt-3">
            Last Name
          </label>
          <input
            type="text"
            id="lastNameEdit"
            className="form-control"
            value={lastNameEdit ? lastNameEdit : ""}
            onChange={lastNameEditHandler}
          ></input>
          {!lastNameValid && (
            <p className="validationError">Please enter last name</p>
          )}
        </div>
        <div>
          <label htmlFor="phoneEdit" className="form-label mt-3">
            Phone (xxx-xxx-xxxx)
          </label>
          <input
            type="text"
            id="phoneEdit"
            className="form-control"
            value={phoneEdit ? phoneEdit : ""}
            onChange={phoneEditHandler}
          ></input>
          {!phoneValid && (
            <p className="validationError">Please enter phone number</p>
          )}
          {!phoneFormatValid && (
            <p className="validationError">Phone number must be xxx-xxx-xxxx</p>
          )}
        </div>
        <button
          type="button"
          className="btn btn-dark ps-4 pe-4 pt-3 pb-3 mt-4 me-2"
          onClick={submitBtnHandler}
        >
          Submit
        </button>
        <button
          type="button"
          className="btn btn-dark ps-4 pe-4 pt-3 pb-3 mt-4"
          onClick={cancelBtnHandler}
        >
          Cancel
        </button>
      </form>
    </div>
  );
}
